module.exports = __webpack_public_path__ + "media/images/compare-img1-800df8ff693937731a268ab90e5a0e83.png";